import React from 'react';
import PropTypes from 'prop-types';
import './Button.styl';

const Button = props => {
  const {
    label = 'button',
    className,
    href,
    style,
    type,
    action,
    key,
    dataAttr,
    target = '_self',
    ...rest
  } = props;

  return (
    <a
      key={key}
      aria-label={label}
      onClick={action}
      {...dataAttr}
      style={style}
      className={className ? `${className} ${type}` : type}
      href={href}
      target={target}
      {...rest}
    >
      {props.children}
    </a>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  key: PropTypes.string,
  action: PropTypes.func,
  href: PropTypes.string,
  dataAttr: PropTypes.object,
  children: PropTypes.node,
};

export default Button;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Button/Button.js